<template>
  <div id="register">
    <div class="registerCont">
      <img src="../assets/leftPic.png" alt="" class="left">
      <div class="right">
        <p class="title">用户注册</p>
        <a-form :form="form" @submit="register" :hideRequiredMark="false" layout="horizontal" class="rightBottom">
          <a-form-item label="用户名：" class="inline">
            <a-input class="input" placeholder="请输入用户名" 
              v-decorator="['uname',{ rules: [{ required: true, message: '请输入正确的用户名',whitespace:true }] }]" 
            />
          </a-form-item>
          <a-form-item label="密码：" class="inline">
            <a-input-password class="input" placeholder="请输入密码"
              v-decorator="['pwd',{ rules: [{ required: true, message: '请输入正确的密码' }] }]" 
             />
          </a-form-item>
          <a-form-item label="性别" class="inline">
            <a-radio-group class="input" name="radioGroup" default-value="M" @change="sexChange">
              <a-radio value="M">
                男
              </a-radio>
              <a-radio value="F">
                女
              </a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="手机号：" class="inline">
            <a-input class="input" placeholder="请输入手机号" 
              v-decorator="['phone',{ rules: [{ required: true, message: '请输入正确的手机号',whitespace:true }] }]" 
            />
          </a-form-item>
          <a-form-item label="身份证号：" class="inline">
            <a-input class="input" placeholder="请输入身份证号" 
              v-decorator="['idcard',{ rules: [{ required: true, message: '请输入正确的身份证号',whitespace:true }] }]" 
            />
          </a-form-item>
          <a-form-item label="邮箱：" class="inline">
            <a-input class="input" placeholder="请输入邮箱" 
              v-decorator="['email',{ rules: [{type:'email', required: true, message: '请输入正确的邮箱',whitespace:true }] }]" 
            />
          </a-form-item>
          <a-form-item label="生日：" class="inline">
            <a-date-picker class="input" @change="dateChange" placeholder="选择日期" 
              v-decorator="['date',{ rules: [{ type:'object', required: true, message: '请选择日期',whitespace:true }] }]" 
             />
          </a-form-item>
          <a-form-item class="alignRight">
            <a-checkbox :checked="isCheckRule" @change="checkRule" ></a-checkbox>
            <span class="underLine" @click="goServe">用户服务条款</span>
            
          </a-form-item>
          <a-form-item class="alighBetween">
            <a-button type="default" @click="cancel">取消</a-button>
            <a-button type="primary" html-type="submit">确定</a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>

import '../sass/register.min.css'

export default {
  name:'register',
  data(){
    return{
      sex:'M',
      isCheckRule:false,
      form:this.$form.createForm(this,{name:'register'}),
    }
  },
  methods:{
    cancel(){
      this.form.resetFields();
    },
    checkRule(e){
      this.isCheckRule = e.target.checked;
    },
    register(e){
      e.preventDefault();
      //去登录
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
          if(this.isCheckRule){
            //已经确认服务条款
            const src = 'register/add';
            const data = {
              nickname:values.uname,
              password:values.pwd,
              sex:this.sex,
              mobile:values.phone,
              idcard:values.idcard,
              mailbox:values.email,
              birthday:Date.parse(values.date.format())
            };
            const registerFun = (res)=>{
              this.$message.success('注册成功');
              this.$router.push({name: "index",query: {}});
            }
            this.$commonApi.$axios(src,data,registerFun);
          }else{
            this.$message.info('请先勾选 用户服务条款');
          }
        }
      });
    },
    sexChange(e){
      this.sex = e.target.value;
    },
    dateChange(e){
      console.log('日期',Date.parse(e.format()) );
    },
    goServe(){
      this.$router.push({name: "serve",query: {}});
    }
  },
  created(){
    this.$myStore.setMessageAction(2);
  },
  mounted(){

  }
}
</script>